import {takeLatest} from 'redux-saga/effects';
/*CONSTANTS*/
import {GET_EVENT, GET_EVENTS,} from '../../constants/EventsConstants';
/*SAGAS*/
import {getEventsSaga} from './getEventsSaga';
import {getEventSaga} from './getEventSaga';


export function* GetEvent(): Generator {
    // @ts-ignore
    yield takeLatest(GET_EVENT, getEventSaga);
}

export function* GetEvents(): Generator {
    // @ts-ignore
    yield takeLatest(GET_EVENTS, getEventsSaga);
}


